module.exports = __webpack_public_path__ + "img/delivery-bike-icon.5662fa63.png";